import { send } from "./axios-wrapper";
import localStorageUtils from '../../../utils/local-storage';

export const refreshToken = async () => {
    const { refreshTokenUrl, sessionId } = JSON.parse(localStorageUtils.getContext());

    const urlObj = new URL(refreshTokenUrl);
    urlObj.searchParams.set('sessionId', sessionId);
    urlObj.searchParams.set('appId', 'patient-app');
    const url = urlObj.toString();

    const options = {
        method: "GET",
        url: url,
        withCredentials: true
    };

    const res = await send(options);
    const status = res.status || res.data.httpStatusCode;
    if (status !== 200) throw res.data;

    localStorageUtils.updateContext(JSON.stringify({
        ...JSON.parse(localStorageUtils.getContext()),
        accessToken: res.data.accessToken
    }));
}; 